import { render, staticRenderFns } from "./NoteComponent.vue?vue&type=template&id=6b7cfed2&"
import script from "./NoteComponent.vue?vue&type=script&lang=ts&"
export * from "./NoteComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NoteComponent.vue?vue&type=style&index=0&id=6b7cfed2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports